<app-detalhe-projeto-analises-gerente-list></app-detalhe-projeto-analises-gerente-list>

<app-detalhe-projeto-analises-spgg-list></app-detalhe-projeto-analises-spgg-list>